module.exports = __webpack_public_path__ + "static/img/zs4.93d9e30.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qualificationDoc/zs4.png
// module id = tzn5
// module chunks = 1